import React, { useEffect, useState, useRef } from "react";
/* global ApplePaySession */
import { Container } from "@mui/material";
import "./PayoutScreen.css";
import logo from "../assets/logo.png";
import logosmall from "../assets/logo_small.png";
import chevronDown from "../assets/chevron-down.svg";
import visa from "../assets/cardtypes/visa.svg";
import mastercard from "../assets/cardtypes/mastercard.svg";
import amex from "../assets/cardtypes/amex.svg";
import diners from "../assets/cardtypes/diners.svg";
import discover from "../assets/cardtypes/discover.svg";
import jcb from "../assets/cardtypes/jcb.svg";
import unionpay from "../assets/cardtypes/unionpay.svg";
import alipay from "../assets/cardtypes/alipay.svg";
import bizum from "../assets/cardtypes/bizum.svg";
import ideal from "../assets/cardtypes/ideal.svg";
import { getTipById } from "../api/tip";
import { getPaises } from "../api/pais";
import { useNavigate, useParams } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import { getTextById } from "../api/text";
import Swal from "sweetalert2";
import { getBusinessByQrId } from "../api/business";
import { generarPago, validarPago, generarPagoGooglePay } from "../api/pago";
import { event } from "../utils/gtag";

function getEmptyBusiness() {
  return {
    nombre_comercial: ""
  };
}

const PayoutScreen = () => {
  const [tip, setTip] = useState({});
  const businessId = useParams().id;
  const [business, setBusiness] = useState(getEmptyBusiness());
  const tipId = useParams().idtip;
  const [textCookeis, setTextCoookies] = useState("");
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [showError, setShowError] = useState(false);
  const [expiryDate, setExpiryDate] = useState("");
  const [expiryError, setExpiryError] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedPrefix, setSelectedPrefix] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [challengeData, setChallengeData] = useState(null);
  const iframeRef = useRef(null);
  const [iframeLoadedOnce, setIframeLoadedOnce] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(false); // Para mostrar el loader
  const [errorMessage, setErrorMessage] = useState(null); // Para mostrar errores
  const [errorMailMessage, setMailErrorMessage] = useState(null);
  const [errorPhoneNumberMessage, setPhoneNumberErrorMessage] = useState(null);
  const [isGooglePayAvailable, setIsGooglePayAvailable] = useState(false);
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);
  const [googlePayScriptLoaded, setGooglePayScriptLoaded] = useState(false);


  const googlePayButtonRef = useRef(null);
  const applePayButtonRef = useRef(null);


  const calcularTasaFinal = (importe, tasa) => {
    console.log("importe", importe);
    console.log("tasa", tasa);
    
    if (!importe || !tasa) return 0;
  
    const porcentaje = tasa.percentage || 0;
    const min = tasa.minimumAmount || 0;
    const max = tasa.maximumAmount || Infinity;
  
    const tasaCalculada = parseFloat(((importe * porcentaje) / 100).toFixed(2));
  
    console.log("tasaCalculada: ", tasaCalculada);
    return Math.min(Math.max(tasaCalculada, min), max);
  };
  
  useEffect(() => {
    event({
      action: "carga_pantalla_pago",
      category: "Pantallas",
      label: "PayoutScreen",
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const textRes = await getTextById("679c9c23474dd68f9a1080d9");
        if (textRes.status === 200) {
          setTextCoookies(textRes.data.content["es"]);
        }
        const tipRes = await getTipById(tipId);
        if (tipRes.status === 200) {
          const tipData = tipRes.data;
          if (tipData.liquidacion) {
            const params = {
              icon: "error",
              title: "Ooops...",
              text: "Rellene de nuevo el formulario",
            };
            Swal.fire(params);
            navigate(`/${businessId}`);
          }
          
          setTip(tipData);
          console.log("tipData", tipData);
          
        } else {
          throw new Error("No se pudo obtener la propina.");
        }
        const businessRes = await getBusinessByQrId(businessId);
        if (businessRes.status === 200) {
          const businessData = businessRes.data;
          setBusiness(businessData);
        } else {
          throw new Error("No se pudo obtener el negocio.");
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [tipId]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getPaises();        
        const response = await getPaises();
        const sorted = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setCountries(sorted);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (countries.length > 0) {
      const userLang = navigator.language.split("-")[1]?.toUpperCase();
      const foundCountry = countries.find((country) => country.code === userLang);
      if (foundCountry) {
        setSelectedCountry(foundCountry.code);
        setSelectedPrefix(foundCountry.prefix);
      }
    }
  }, [countries]);

  const handleChangeCountry = (e) => {
    event({
      action: "seleccion_pais_tarjeta",
      category: "Pagos",
      label: e.target.value,
    });

    const code = e.target.value;
    setSelectedCountry(code);
    const country = countries.find((c) => c.code === code);
    if (country) {
      setSelectedPrefix(country.prefix);
    }
  };

  const getFlagUrl = (code) => {
    return `https://flagcdn.com/w40/${code.toLowerCase()}.png`;
  };
  

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://pay.google.com/gp/p/js/pay.js";
    script.async = true;
    script.onload = () => {
      setGooglePayScriptLoaded(true);
    };
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    if (googlePayScriptLoaded && googlePayButtonRef.current) {
      initializeGooglePay();
    }
  }, [googlePayScriptLoaded, googlePayButtonRef.current]);
    
  useEffect(() => {
    if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
      setIsApplePayAvailable(true);
      const button = document.createElement("button");
      button.className = "apple-pay-button";
      button.addEventListener("click", startApplePaySession);
      
      if (applePayButtonRef.current) {
        applePayButtonRef.current.innerHTML = "";
        applePayButtonRef.current.appendChild(button);
      }
    } else {
      setIsApplePayAvailable(false);
      console.warn("❌ Apple Pay no está disponible en este navegador");
    }
  }, []);
  
  /****GOOGLE PAY */

  const initializeGooglePay = () => {

    const paymentsClient = new window.google.payments.api.PaymentsClient({
      environment: "TEST", // Usa "PRODUCTION" solo en prod
    });
  
    const isReadyToPayRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: "CARD",
          parameters: {
            allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
            allowedCardNetworks: ["MASTERCARD", "VISA"],
          },
        },
      ],
    };
  
    paymentsClient.isReadyToPay(isReadyToPayRequest)
      .then((response) => {
        console.log("🟢 isReadyToPay response:", response);
        if (response.result) {
          console.log("✅ Google Pay está disponible");
          const button = paymentsClient.createButton({
            onClick: () => onGooglePayPressed(paymentsClient),
            buttonColor: "black",
            buttonType: "short",
            buttonRadius: 30,
            buttonSizeMode: "fill"
          });
          console.log(googlePayButtonRef);
          
          if (googlePayButtonRef.current) {
            setIsGooglePayAvailable(true);
            googlePayButtonRef.current.innerHTML = "";
            googlePayButtonRef.current.appendChild(button);
          } else {
            setIsGooglePayAvailable(false);
            console.warn("⚠️ googlePayButtonRef todavía es null");
          }
        } else {
          setIsGooglePayAvailable(false);
          console.warn("⚠️ Google Pay NO está disponible");
        }
      })
      .catch((err) => {
        console.error("❌ Error en isReadyToPay:", err);
      });
  };  

  function toBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
  }  
  
  const onGooglePayPressed = async (paymentsClient) => {
    try {
      const totalAmount = (
        tip.importe.import +
        (tip.clickTaxes ? calcularTasaFinal(tip.importe.import, tip.tasa) : 0)
      ).toFixed(2);

      event({
        action: "iniciar_google_pay",
        category: "Pagos",
        label: "GooglePay",
        value: totalAmount || 0,
      });
      
      const paymentDataRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: "CARD",
            tokenizationSpecification: {
              type: "PAYMENT_GATEWAY",
              parameters: {
                gateway: "redsys",
                gatewayMerchantId: "263100000", // tu merchantCode real
              },
            },
            parameters: {
              allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
              allowedCardNetworks: ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"],
            },
          },
        ],
        merchantInfo: {
          merchantName: "Tipify", // Nombre visible
          merchantId: 'XXXXXXXXXXXXXXXXXXXX',
          merchantOrigin: 'https://tipify.tech'
        },
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: totalAmount,
          currencyCode: "EUR",
        },
      };

      const paymentData = await paymentsClient.loadPaymentData(paymentDataRequest);
      const rawToken = paymentData.paymentMethodData.tokenizationData.token;
      console.log("✅ TOKEN JSON (raw):", rawToken);
      console.log("✅ TOKEN JSON (parsed):", JSON.parse(rawToken)); // Debería funcionar si está bien formado

      const tokenBase64 = btoa(unescape(encodeURIComponent(rawToken)));
      console.log("✅ Base64 final que se enviará:", tokenBase64);

      const decodedAgain = decodeURIComponent(escape(atob(tokenBase64)));
      console.log("🔁 Token decodificado:", decodedAgain);

      
      await generarPagoGooglePay(tokenBase64, tip.importe?.import, tip._id);
    } catch (error) {
      event({
        action: "error_pago_google_pay",
        category: "Pagos",
        label: "Error al cargar Google Pay",
      });
    }
  };

  /****APPLE PAY */

  const startApplePaySession = async () => {
    try {
      const totalAmount = (
        tip.importe.import +
        (tip.clickTaxes ? calcularTasaFinal(tip.importe.import, tip.tasa) : 0)
      ).toFixed(2);

      event({
        action: "iniciar_apple_pay",
        category: "Pagos",
        label: "ApplePay",
        value: totalAmount || 0,
      });
    
      const paymentRequest = {
        countryCode: "ES",
        currencyCode: "EUR",
        supportedNetworks: ["visa", "masterCard", "amex", "discover", "jcb", "unionPay"],
        merchantCapabilities: ["supports3DS"],
        total: {
          label: "Tipify",
          amount: totalAmount,
          type: "final"
        }
      };
    
      const session = new ApplePaySession(3, paymentRequest);
    
      session.onvalidatemerchant = async (event) => {
        try {
          // 🔁 Llamás a tu backend para obtener el merchantSession de Apple
          const res = await fetch("/api/applepay/validate-merchant", {
            method: "POST",
            body: JSON.stringify({ validationURL: event.validationURL }),
            headers: { "Content-Type": "application/json" }
          });
    
          const merchantSession = await res.json();
          session.completeMerchantValidation(merchantSession);
        } catch (error) {
          console.error("❌ Error validando merchant:", error);
          session.abort();
        }
      };
    
      session.onpaymentauthorized = async (event) => {
        const token = event.payment.token.paymentData; // lo que luego mandarás a Redsys
        try {
          // 🔁 Mandá el token a tu backend para procesar con Redsys
          const res = await fetch("/api/applepay/process-payment", {
            method: "POST",
            body: JSON.stringify({
              token,
              amount: totalAmount,
              tipId: tip._id
            }),
            headers: { "Content-Type": "application/json" }
          });
    
          const data = await res.json();
          if (data.success) {
            session.completePayment(ApplePaySession.STATUS_SUCCESS);
            navigate("/success");
          } else {
            session.completePayment(ApplePaySession.STATUS_FAILURE);
            setErrorMessage("No se pudo procesar el pago con Apple Pay.");
          }
        } catch (error) {
          session.completePayment(ApplePaySession.STATUS_FAILURE);
          setErrorMessage("Error inesperado con Apple Pay.");
        }
      };
    
      session.begin();
    } catch (error) {
      event({
        action: "error_pago_apple_pay",
        category: "Pagos",
        label: "Error al autorizar con Apple Pay",
      });
    }
  };
  
  const currentYear = new Date().getFullYear() % 100;
  const maxYear = currentYear + 50;

  const handlePaymentChange = (e) => {
    const metodo = e.target.value;
    event({
      action: "seleccion_metodo_pago",
      category: "Pagos",
      label: metodo, // 'card' o 'bizum'
    });
    setPaymentMethod(e.target.value);
  };
  
  const formatCardNumber = (value) => {
    return value
      .replace(/\D/g, "") // Elimina todo lo que no sea número
      .replace(/(.{4})/g, "$1 ") // Inserta un espacio cada 4 caracteres
      .trim(); // Elimina espacios extras al final
  };

  const validateCardNumber = (number) => {
    let cleanNumber = number.replace(/\D/g, "");
    let digits = cleanNumber.split("").reverse().map(Number);
    let checksum = digits.reduce((sum, digit, index) => {
      if (index % 2 !== 0) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      return sum + digit;
    }, 0);
    return checksum % 10 === 0;
  };

  const isValidLength = (number) => {
    let cleanNumber = number.replace(/\D/g, "");
    return cleanNumber.length === 16 || cleanNumber.length === 15;
  };
    
  const handleCardChange = (e) => {
    if (errorMessage) setErrorMessage("");
    let formattedNumber = formatCardNumber(e.target.value);
    setCardNumber(formattedNumber);

    if (isValidLength(formattedNumber)) {
      let valid = validateCardNumber(formattedNumber);
      setIsValid(valid);
      setShowError(true); // Solo mostrar error si ya tiene la longitud correcta
    } else {
      setShowError(false); // No mostrar error hasta que complete el número
    }
  };

  const handleExpiryChange = (e) => {
    if (errorMessage) setErrorMessage("");
    let value = e.target.value.replace(/\D/g, ""); // Solo números
    let deleting = expiryDate.length > value.length;
    let newExpiry = value;
  
    // 🛠️ Detectar si el navegador autocompleta MMYYYY y corregirlo a MM / YY
    if (value.length === 6) {
      let month = value.substring(0, 2);
      let year = value.substring(4, 6);
      newExpiry = `${month} / ${year}`;
      setExpiryDate(newExpiry);
      return;
    }
  
    if (deleting) {
      if (expiryDate.endsWith(" / ") && value.length === 2) {
        value = value.substring(0, 1);
      }
      setExpiryDate(value);
      setExpiryError(false);
      return;
    }
  
    if (value.length === 1) {
      let month = parseInt(value, 10);
      newExpiry = month > 1 ? `0${month} / ` : `${month}`;
    } else if (value.length === 2) {
      let month = parseInt(value, 10);
      if (month >= 1 && month <= 12) {
        newExpiry = `${month < 10 ? "0" + month : month} / `;
      } else {
        setExpiryError(true);
        return;
      }
    } else if (value.length === 3) {
      let month = value.substring(0, 2);
      let year = value.substring(2, 3);
      newExpiry = `${month} / ${year}`;
    } else if (value.length >= 4) {
      let month = value.substring(0, 2);
      let year = value.substring(2, 4);
      let fullYear = parseInt("20" + year, 10);
  
      if (fullYear >= 2000 + currentYear && fullYear <= 2000 + maxYear) {
        newExpiry = `${month} / ${year}`;
        setExpiryError(false);
      } else {
        setExpiryError(true);
        return;
      }
    }
  
    setExpiryDate(newExpiry);
  };

  const handleCVCChange = (e) => {
    if (errorMessage) setErrorMessage("");
  }

  const handleEmailChange = (e) => {
    event({
      action: "input_email",
      category: "Pagos",
      label: "Campo Email",
    });
    if (errorMailMessage) setMailErrorMessage("");
  }

  const handleNameChange = (e) => {
    event({
      action: "input_nombre_tarjeta",
      category: "Pagos",
      label: "Campo Nombre",
    });
    if (errorMessage) setErrorMessage("");
  }

  const handlePhoneNumberChange = (e) => {
    event({
      action: "input_bizum_phone",
      category: "Pagos",
      label: "Bizum",
    });
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, "");

    if (value !== numericValue) {
      e.target.value = numericValue;
    }
    if (errorPhoneNumberMessage) setPhoneNumberErrorMessage("");
  }

  const handlePayout = async () => {
    const email = document.getElementById("email").value;
    const cvc = document.getElementById("cvc")?.value || "";
    const expiryDate = document.getElementById("expiryDate")?.value || "";
    const nameCard = document.getElementById("name")?.value || "";
    const country = document.getElementById("country")?.value || "";
    const rawPhoneNumber = document.getElementById("phoneNumber")?.value || "";
    const fullPhoneNumber = `${selectedPrefix}${rawPhoneNumber.replace(/^0+/, "")}`;

    const newOrderId = Math.floor(Math.random() * 100000);
    const newAmount = tip.importe.import + (tip.clickTaxes ? calcularTasaFinal(tip.importe.import, tip.tasa) : 0);

    /*** Consideramos el mail como opcional
    if (!email) {
      setMailErrorMessage("El email es obligatorio.");
      return;
    }
    */
    if (!paymentMethod) {
      Swal.fire({ icon: "warning", title: "Seleccionar método de pago", text: "Por favor, para poder dar la propina elige un método de pago." });
      return;
    }
    if (paymentMethod === "bizum") {
      if (!fullPhoneNumber) {
        setPhoneNumberErrorMessage("El número de teléfono es obligatorio.");
        return;
      }
      try {
        const browserInfo = {
          browserJavascriptEnabled: "true",
          browserAcceptHeader: "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8,application/json",
          browserUserAgent: navigator.userAgent || "Mozilla/5.0",
          browserJavaEnabled: navigator.javaEnabled() ? "true" : "false",
          browserLanguage: navigator.language || "ES-es",
          browserColorDepth: window.screen.colorDepth.toString(),
          browserScreenHeight: window.screen.height.toString(),
          browserScreenWidth: window.screen.width.toString(),
          browserTZ: new Date().getTimezoneOffset().toString()
        };
  
        const response = await generarPago(
          newAmount,
          newOrderId,
          null,
          null,
          null,
          null,
          email,
          tip._id,
          browserInfo,
          "bizum",
          fullPhoneNumber
        );
  
        if (response.status !== 200) throw new Error("Error al procesar pago Bizum.");
  
        const responseData = response.data;
        console.log("📌 Respuesta del backend y mostramos setCheckingStatus...:", responseData);

        setCheckingStatus(true);
        console.log("newOrderId: ", responseData?.detalle?.Ds_Order);
        
        pollEstadoPago(responseData?.detalle?.Ds_Order);
      } catch (error) {
        setPhoneNumberErrorMessage("Error al procesar el pago con Bizum. ¿Tienes Bizum activo en tu banco?");
      }

      return;
    }
    if (paymentMethod === "card") {
      if (!cardNumber) {
        setErrorMessage("El número de la tarjeta es obligatorio.");
        return;
      }
      if (!expiryDate) {
        setErrorMessage("La fecha de expiración de la tarjeta es obligatoria.");
        return;
      }
      if (!cvc) {
        setErrorMessage("El CVC es obligatorio. ¿Te ayudamos a cómo encontrarlo?");
        return;
      }
      if (!nameCard) {
        setErrorMessage("El nombre del titular de la tarjeta es obligatorio.");
        return;
      }
      if (!country) {
        setErrorMessage("Selecciona el país de tu tarjeta.");
        return;
      }      
      try {
        // 1️⃣ 🚀 Llamamos a la API de pago para verificar si requiere challenge
        const browserInfo = {
          browserJavascriptEnabled: "true",
          browserAcceptHeader: "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8,application/json",
          browserUserAgent: navigator.userAgent || "Mozilla/5.0",
          browserJavaEnabled: navigator.javaEnabled() ? "true" : "false",
          browserLanguage: navigator.language || "ES-es",
          browserColorDepth: window.screen.colorDepth.toString(),
          browserScreenHeight: window.screen.height.toString(),
          browserScreenWidth: window.screen.width.toString(),
          browserTZ: new Date().getTimezoneOffset().toString()
        };
        const response = await generarPago(newAmount, newOrderId, cardNumber, expiryDate, cvc, nameCard, email, tip._id, browserInfo);
        if (response.status !== 200) throw new Error("Error al procesar el pago.");

        const responseData = response.data;
        console.log("📌 Respuesta del backend:", responseData);

        // 2️⃣ ✅ Si NO requiere challenge, procesamos el pago normalmente
        if (!responseData.requiresChallenge) {
            console.log("✅ No se necesita challenge, pago procesado correctamente.");
            navigate(`/success`);
        } else {
          console.log("🔒 Challenge requerido. Verificando autenticación...");
          console.log("🔒 Challenge requerido. Mostrando iframe...");
          setChallengeData({
            acsURL: responseData.acsURL,
            creq: responseData.creq,
            orderId: responseData.orderId
          });
          setTimeout(() => {
            document.getElementById("challengeForm")?.submit();
          }, 100);
        }
      } catch (error) {
        event({
          action: "error_pago",
          category: "Pagos",
          label: "PayoutScreen",
        });
        setErrorMessage("No hemos podido autorizar el pago. Por favor, revisa los datos de tu tarjeta o prueba con otro método.");
      }

      return;
    }
  };

  const pollEstadoPago = async (orderId, maxAttempts = 10) => {
    let attempts = 0;
    const interval = setInterval(async () => {
      try {
        const res = await validarPago(orderId); // 🔄 Usamos tu función
        const data = res.data;
        if (data.status === 'success') {
          clearInterval(interval);

          navigate(`/success`);
        } else if (data.status === 'failed') {
          clearInterval(interval);
          setCheckingStatus(false);
          if (data.paymentMethod === "bizum") {
            setPhoneNumberErrorMessage("No hemos podido autorizar el pago. Por favor, revisa los datos de tu teléfono o prueba con otro método.");
          } else {
            setErrorMessage("No hemos podido autorizar el pago. Por favor, revisa los datos de tu tarjeta o prueba con otro método.");
          }
        }
  
        if (++attempts >= maxAttempts) {
          clearInterval(interval);
          setCheckingStatus(false);
          setErrorMessage("La operación ha excedido el tiempo de espera. Por favor, inténtalo nuevamente.");
        }
  
      } catch (e) {
        clearInterval(interval);
        setCheckingStatus(false);
        setErrorMessage("No hemos podido verificar el estado del pago en este momento. Puede tratarse de un error temporal. Si has recibido un cargo, no te preocupes: lo estamos revisando y te contactaremos en breve.");
      }
    }, 3000); // cada 3 segundos
  };
  

  if (!tip || !tip.importe?.id) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Tipify Logo" className="loading-logo pulse-effect" />
      </div>
    );
  }

  return (
    
    <Container className="success-container px-0">
      {checkingStatus && (
        <div className="fullscreen-loader">
          <img src={logosmall} alt="Cargando" className="pulse-logo" />
        </div>
      )}
      {challengeData && (
        <>
          <form
            id="challengeForm"
            action={challengeData.acsURL}
            method="POST"
            target="challengeIframe"
            style={{ display: "none" }}
          >
            <input type="hidden" name="creq" value={challengeData.creq} />
          </form>

          <iframe
            name="challengeIframe"
            ref={iframeRef}
            style={{ width: "100%", height: "500px", opacity: 1, border: "1px solid #ccc", marginTop: "10px" }}
            onLoad={() => {
              if (!iframeLoadedOnce) {
                console.log("🔄 Challenge iframe loaded primera vez");
                setIframeLoadedOnce(true);
              } else {
                console.log("🔄 Challenge iframe loaded segunda vez (post-validación)");
                setCheckingStatus(true);
                console.log("🚀 Activando loader de validación con orderId:", challengeData.orderId);

                pollEstadoPago(challengeData.orderId);
              }
            }}
          />
        </>
      )}

      <div className="logo-container mt-3">
        <img src={logo} alt="Tipify Logo" className="logo2" />
      </div>
      
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="p-2 py-1">
              <div>Propina para <strong>{business.nombre_comercial}</strong></div>
              <h1 className="amount p-2">
                {(
                  tip.importe.import +
                  (tip.clickTaxes ? calcularTasaFinal(tip.importe.import, tip.tasa) : 0)
                ).toLocaleString("es-ES", { minimumFractionDigits: 2 })}€
              </h1>
              {tip.clickTaxes && (<>
              <div className="amountDetails mb-2 py-2 px-3 d-flex justify-content-between"
                onClick={() => {
                  event({
                    action: isOpen ? "ocultar_detalles_pago" : "ver_detalles_pago",
                    category: "Pagos",
                    label: "PayoutScreen",
                  });
                  setIsOpen(!isOpen);
                }}
              >
                <div>{isOpen ? "Ocultar detalles" : "Ver detalles"}</div>
                <img src={chevronDown} alt="view details" className="chevronRight"
                  style={{
                    transition: "transform 0.3s ease",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
                  }}
                />
              </div>
              <div 
                style={{
                  maxHeight: isOpen ? "200px" : "0px",
                  overflow: "hidden",
                  transition: "max-height 0.3s ease-out"
                }}
              >
                <div className="px-2 py-3">
                  <div className="d-flex justify-content-between">
                    <div>Tip</div>
                    <div>{(tip.importe.import).toLocaleString("es-ES", { minimumFractionDigits: 2 })}€</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Gastos de transacción<span className="heartbeat">💚</span></div>
                    <div>{(tip.clickTaxes ? calcularTasaFinal(tip.importe.import, tip.tasa) : 0).toLocaleString("es-ES", { minimumFractionDigits: 2 })}€</div>
                  </div>
                  <hr className="my-2"/>
                  <div className="d-flex justify-content-between">
                    <div>Total</div>
                    <div>{(tip.importe.import + (tip.clickTaxes ? calcularTasaFinal(tip.importe.import, tip.tasa) : 0)).toLocaleString("es-ES", { minimumFractionDigits: 2 })}€</div>
                  </div>
                </div>
              </div></>)}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card mx-2 mb-2">
              <div className="card-body">
                <div className="mt-2 d-flex justify-content-around">
                  <div ref={googlePayButtonRef} className="google-pay-button-container"></div>
                  {isApplePayAvailable && (<div ref={applePayButtonRef} className="apple-pay-button-container"></div>)}
                </div>
                <div className="divider">
                  <hr />
                  <span className="dividerText">O paga mediante otros métodos</span>
                </div>
                <div className="my-3">
                  <form id="payment-form" method="POST">
                    <div className="my-2">
                      <input type="email" className="form-control" id="email" aria-describedby="emailInput" placeholder="Email opcional"
                        onChange={handleEmailChange}
                      />
                    </div>
                    {errorMailMessage && (
                      <div className="error-message">
                        <p>{errorMailMessage}</p>
                      </div>
                    )}
                    <div className="d-flex justify-content-start">
                    {selectedCountry && (
                      <div className="flagPrefix d-flex align-items-center px-2">
                        <img
                          src={getFlagUrl(selectedCountry)}
                          alt={selectedCountry}
                          width="12"
                          height="9"
                          className="flagCountry mx-1"
                        />
                        {selectedPrefix}
                      </div>
                    )}
                    <select
                      className="form-control"
                      id="country"
                      value={selectedCountry}
                      onChange={handleChangeCountry}
                    >
                      <option value="">Selecciona un país</option>
                      {countries.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    </div>
                    <div className="mt-3 mb-2">Método de pago</div>
                    <div className="card">
                      <div className="card-body">
                        <div className="form-check py-2 d-flex justify-content-between">
                          <div>
                            <input className="form-check-input" type="radio" name="paymentMethod" id="cardmethod" value="card"
                              checked={paymentMethod === "card"}
                              onChange={handlePaymentChange}
                            />
                            <label className="form-check-label ms-1" for="cardmethod">
                              Tarjeta de crédito (4548812049400004)
                            </label>
                          </div>
                          {(paymentMethod !== "card") && (<div className="card-icons">
                            <img src={visa} alt="Visa" width="16" className="me-1"/>
                            <img src={mastercard} alt="MasterCard" width="16" className="me-1"/>
                            <img src={amex} alt="Amex" width="16" className="me-1"/>
                            <img src={diners} alt="Diners" width="16" className="me-1"/>
                            <img src={discover} alt="discover" width="16" className="me-1"/>
                            <img src={jcb} alt="jcb" width="16" className="me-1"/>
                            <img src={unionpay} alt="unionpay" width="16"/>
                          </div>)}
                        </div>
                        {paymentMethod === "card" && (<div className="ms-1 mb-2">
                          <div className="mt-2 mb-0">Número de tarjeta</div>
                          <div className="position-relative">
                            <input type="tel" className={`form-control ${!isValid && showError ? "is-invalid" : ""}`} id="cardNumber" aria-describedby="cardNumberInput" placeholder="1234 1234 1234 1234"
                              inputMode="numeric"
                              pattern="\d*"
                              maxLength="19"
                              value={cardNumber}
                              onChange={handleCardChange}
                            />
                            {(!showError || isValid) && <div className="card-icons position-absolute end-0 translate-middle-y d-flex px-2">
                              <img src={visa} alt="Visa" width="20" className="me-1"/>
                              <img src={mastercard} alt="MasterCard" width="20" className="me-1"/>
                              <img src={amex} alt="Amex" width="20" className="me-1"/>
                              <img src={diners} alt="Diners" width="20"/>
                            </div>}
                            {showError && !isValid && <div className="text-danger mt-1">Número de tarjeta inválido</div>}
                          </div>
                          <div className="d-flex justify-content-between pb-2">
                            <div class="w-100">
                              <input type="tel" className={`form-control ${expiryError ? "is-invalid" : ""}`} id="expiryDate" aria-describedby="expiryDateInput" placeholder="MM / AA"
                                inputMode="numeric"
                                pattern="\d*"
                                maxLength="7"
                                value={expiryDate}
                                onChange={handleExpiryChange}
                              />
                              {expiryError && <div className="text-danger mt-1">La fecha no es correcta</div>}
                            </div>
                            <div class="w-100">
                              <input type="tel" className="form-control" id="cvc" aria-describedby="cvcInput" placeholder="CVC" autocomplete="cc-csc"
                                inputMode="numeric"
                                pattern="\d*"
                                maxLength="4"
                                onChange={handleCVCChange}
                              />
                            </div>
                          </div>
                          <div>
                            <input type="text" className="form-control mb-2" id="name" aria-describedby="nameInput" placeholder="Nombre completo en la tarjeta"
                              onChange={handleNameChange}
                            />
                          </div>
                          {errorMessage && (
                            <div className="error-message">
                              <p>{errorMessage}</p>
                            </div>
                          )}
                        </div>)}
                        <div className="form-check py-2 d-flex justify-content-between">
                          <div>
                            <input className="form-check-input" type="radio" name="paymentMethod" id="bizummethod" value="bizum"
                              checked={paymentMethod === "bizum"}
                              onChange={handlePaymentChange}
                            />
                            <label className="form-check-label ms-1" for="bizummethod">
                              Bizum (700000000)
                            </label>
                          </div>
                          <img src={bizum} alt="Bizum" height="18" />
                        </div>
                        {paymentMethod === "bizum" && (<div className="ms-1 mb-2">
                          <div className="mt-2 mb-0">Número de Teléfono</div>
                          <div>
                            <input type="tel" className="form-control mb-2" id="phoneNumber" aria-describedby="phoneNumberInput" placeholder="Número de teléfono con servicio Bizum"
                              inputMode="numeric"
                              pattern="\d*"
                              autoComplete="tel-national"
                              onChange={handlePhoneNumberChange}
                            />
                          </div>
                          {errorPhoneNumberMessage && (
                            <div className="error-message">
                              <p>{errorPhoneNumberMessage}</p>
                            </div>
                          )}
                        </div>)}
                        {/*
                        //Se inhabilita método pago alipay
                        <div className="form-check py-2 d-flex justify-content-between">
                          <div>
                            <input className="form-check-input" type="radio" name="paymentMethod" id="alipaymethod" value="alipay"
                              checked={paymentMethod === "alipay"}
                              onChange={handlePaymentChange}
                            />
                            <label className="form-check-label ms-1" for="alipaymethod">
                              Alipay
                            </label>
                          </div>
                          <img src={alipay} alt="alipay" width="16"/>
                        </div>
                        */}
                        {/*
                        //Se inhabilita método pago ideal
                        <div className="form-check py-2 d-flex justify-content-between">
                          <div>
                            <input className="form-check-input" type="radio" name="paymentMethod" id="idealmethod" value="ideal"
                              checked={paymentMethod === "ideal"}
                              onChange={handlePaymentChange}
                            />
                            <label className="form-check-label ms-1" for="idealmethod">
                              iDEAL
                            </label>
                          </div>
                          <img src={ideal} alt="ideal" width="16"/>
                        </div>
                        */}
                      </div>
                    </div>
                    <input type="hidden" name="Ds_SignatureVersion" value="HMAC_SHA256_V1" />
                    <input type="hidden" id="Ds_MerchantParameters" name="Ds_MerchantParameters" />
                    <input type="hidden" id="Ds_Signature" name="Ds_Signature" />
                  </form>
                </div>
                <div>
                  <button type="button" className="btn-pay w-100"
                    onClick={async () => {
                      event({
                        action: "click_dar_propina",
                        category: "Pagos",
                        label: "PayoutScreen",
                        value: tip?.importe?.import || 0,
                      });
                      await handlePayout();
                    }}
                  >Dar propina</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CookieConsent
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          textAlign: "left",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          maxHeight: "35%",
        }}
        buttonStyle={{
          backgroundColor: "#66bc5f",
          color: "#fff",
          fontSize: "16px",
          padding: "15px",
          width: "100%",
        }}
        cookieName="myAwesomeCookieName3"
        expires={999}
        buttonText="Aceptar"
        overlay
      >
        <div dangerouslySetInnerHTML={{ __html: textCookeis }} />
        <a
          href="/politica-cookies"
          style={{ color: "#fff", textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Leer más
        </a>
      </CookieConsent>
    </Container>
    
  );
};

export default PayoutScreen;
